import { render, staticRenderFns } from "./DocConvertDetail.vue?vue&type=template&id=5a4fdd31&scoped=true"
import script from "./DocConvertDetail.vue?vue&type=script&lang=js"
export * from "./DocConvertDetail.vue?vue&type=script&lang=js"
import style0 from "./DocConvertDetail.vue?vue&type=style&index=0&id=5a4fdd31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4fdd31",
  null
  
)

export default component.exports